module.exports = __webpack_public_path__ + "static/media/YF93_1.6d324940.jpg";